import { useCallback, useContext, useEffect, useState } from "react";

import { GalleryContext } from "./GalleryContext";
import ICustomImageData from "./customImageDataInterface";

export const useGallery = (
  /** List of images */
  images?: ICustomImageData[],
  /** Current active item */
  activeItem?: ICustomImageData,
  /** Returns selected `Image` entity */
  onSelect?: (image: ICustomImageData) => void,
): [
  ICustomImageData,
  (image: ICustomImageData) => void,
  ICustomImageData[],
  () => void,
  () => void,
] => {
  const context = useContext(GalleryContext);

  const imageSet = images || context?.images;

  const [selectedImage, setSelectedImage] = useState<ICustomImageData>(
    activeItem || context?.activeItem || (imageSet && imageSet[0]),
  );

  useEffect(() => {
    (activeItem || context?.activeItem) &&
      setSelectedImage(activeItem || context?.activeItem);
  }, [activeItem, context]);

  const handleOnSelect = useCallback(
    (image: ICustomImageData) => {
      if (context?.onSelect) {
        context.onSelect(image);
      } else {
        setSelectedImage(image);
      }
      onSelect && onSelect(image);
    },
    [context, onSelect],
  );

  const moveRight = useCallback(() => {
    const index = imageSet?.indexOf(selectedImage);
    if (index < imageSet.length - 1) handleOnSelect(imageSet[index + 1]);
  }, [handleOnSelect, imageSet, selectedImage]);

  const moveLeft = useCallback(() => {
    const index = imageSet?.indexOf(selectedImage);
    if (index > 0) handleOnSelect(imageSet[index - 1]);
  }, [handleOnSelect, imageSet, selectedImage]);

  return [selectedImage, handleOnSelect, imageSet, moveLeft, moveRight];
};
